import { Observable, UnaryFunction, filter, pipe } from 'rxjs';
import { PushData } from './messaging-push.model';

export type PhpPushType = 'FAMILY_MSG' | 'RESIDENT_CONTACT' | 'TV_CHANNEL';

export type PhpPushAction = 'ADD' | 'REMOVE' | 'SEND' | 'START_SCAN' | 'END_SCAN';

export interface PushPhpData {
  elioId: number;
  offreId: number;
  entity: PhpPushType;
  action: PhpPushAction;
  itemId: number;
}

export function ofPhpPushType<T extends PushData | PushPhpData>(
  pushType: PhpPushType,
  pushAction: PhpPushAction
): UnaryFunction<Observable<T>, Observable<PushPhpData>>;
export function ofPhpPushType<T extends PushData | PushPhpData>(
  pushType: PhpPushType[],
  pushAction: PhpPushAction
): UnaryFunction<Observable<T>, Observable<PushPhpData>>;
export function ofPhpPushType<T extends PushData | PushPhpData>(
  pushType: PhpPushType,
  pushAction: PhpPushAction[]
): UnaryFunction<Observable<T>, Observable<PushPhpData>>;
export function ofPhpPushType<T extends PushData | PushPhpData>(
  pushType: PhpPushType[],
  pushAction: PhpPushAction[]
): UnaryFunction<Observable<T>, Observable<PushPhpData>>;
export function ofPhpPushType<T extends PushData | PushPhpData>(
  pushType: PhpPushType | PhpPushType[],
  pushAction: PhpPushAction | PhpPushAction[]
): UnaryFunction<Observable<T>, Observable<PushPhpData>> {
  const pushTypes = Array.isArray(pushType) ? pushType : [pushType];
  const pushActions = Array.isArray(pushAction) ? pushAction : [pushAction];
  return pipe(
    filter((push: PushData | PushPhpData): push is PushPhpData => (push as PushData).originType === undefined),
    filter((push: PushPhpData) => pushTypes.includes(push.entity) && pushActions.includes(push.action))
  );
}
